// The Bubbles message display's rows (#141): bubbles like a messaging app. Others' on the left with their avatar beside
// the last bubble of a run and their name above the first, mine on the right; a centred time line after a pause.
// Chosen in MessageList's MESSAGE_LAYOUTS. Its CSS is the `data-density="bubbles"` rules in styles.css and lists.css.
import { timeFmt, MessageTime } from "../MessageTime.tsx";
import { Avatar } from "../ui.tsx";
import { useNameLook } from "../../coloredNames.ts";
import { dayLabel, DAY_PX, type FrameProps, type MessageLayout, type RowItem } from "../MessageLayout.ts";

function ChatsFrame({ it, name, mine, quiet, oneToOne, tags, replyRef, children }: FrameProps) {
  const { m, first, last } = it;
  const look = useNameLook(m.authorId);
  return (
    <div className="msg-row">
      {!mine && <div className="gutter">{last && <Avatar id={m.authorId} name={name} size={30} />}</div>}
      {mine && !quiet && <MessageTime ts={m.ts} className="time-hover" />}
      <div className="msg-col">
        {first && !mine && !oneToOne && (
          <div className="who">
            <strong className={look.className} style={look.style}>{name}</strong>
            {tags}
          </div>
        )}
        {replyRef}
        {children}
      </div>
      {!mine && !quiet && <MessageTime ts={m.ts} className="time-hover" />}
    </div>
  );
}

/** The centred line above a message after a pause or on a new day: "Today 2:41 PM". */
function TimeLine({ it }: { it: RowItem }) {
  if (!it.stamp) return null;
  return (
    <div className="time-line" role="separator">
      <b>{dayLabel(it.m.ts)}</b> {timeFmt.format(it.m.ts)}
    </div>
  );
}

export const chatsMessages: MessageLayout = {
  id: "bubbles",
  Stamp: TimeLine,
  rowClass: (it, mine, editing) => `${mine ? " mine" : " theirs"}${it.last ? " last" : ""}${editing ? " editing" : ""}`,
  Frame: ChatsFrame,
  Bubble: ({ bare, children }) => <div className={`bubble${bare ? " bare" : ""}`}>{children}</div>,
  stampPx: (it) => (it.stamp ? DAY_PX : 0),
  // A small name line above the first of a run, and a gap between runs (tighter when compact).
  headPx: (it, compact) => (it.first ? (compact ? 12 : 22) : 2),
  replyPx: 28,
  textPx: (body, width) => {
    // The bubble is at most 520 px (70% of the screen on a phone), in 15 px text, with 8 px above and below.
    const perLine = Math.max(14, (Math.min(520, width * 0.7) - 24) / 7.8);
    return 16 + 21 * body.split("\n").reduce((n, line) => n + Math.max(1, Math.ceil(line.length / perLine)), 0);
  },
  key: (it) => `${+it.first}${+it.last}${+it.newDay}${+it.stamp}`,
};
